<template>
    <balance :tariff="tariff" />
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Balance from './Balance';

export default {
    name: 'balance-container',
    components: {
        Balance,
    },
    computed: {
        ...mapState('profileTariff', ['tariff'])
    }
}
</script>



// WEBPACK FOOTER //
// BalanceContainer.vue?16ff0c54